import React, { ReactElement, useMemo } from 'react'
import useDetermineTypeOfHeader from 'utils/useDetermineTypeOfHeader'
import HomepageDropdownBase from './HomepageDropdowns/HomepageDropdownBase'
import { useAppSelector } from 'store/hooks'
import { noRedirectHomePagePath } from 'layouts'

export function OrgAndPersonalDropdown(): ReactElement {
  const { isPersonalHeader } = useDetermineTypeOfHeader()
  const sessionToken = useAppSelector(s => s.persistData.sessionToken)

  const options = useMemo(
    () => [
      {
        header: 'Organization',
        href: sessionToken ? `${noRedirectHomePagePath}` : '/',
      },
      {
        header: 'Personal',
        href: sessionToken ? `/personal${noRedirectHomePagePath}` : `/personal`,
      },
    ],
    [sessionToken],
  )

  return (
    <HomepageDropdownBase
      testId="org-and-personal-dropdown"
      ariaLabel="Organization and personal dropdown"
      variant="roundedSimple"
      sxContainer={{
        flexDirection: 'column',
        py: '0.8rem',
        width: ['calc(100vw - 1rem)', '16rem'],
      }}
      sx={{
        ':not(.tippy-box)': {
          border: '1px solid',
          borderColor: 'lightSteelBlue',
          px: '1.2rem',
          '@media screen and (max-width: 1400px)': {
            px: '0.8rem',
          },
        },
        px: '0.6rem',
        flexShrink: 0,
      }}
      sxButton={{
        px: '0.8rem',
        py: '0.6rem',
        m: 0,
      }}
      dropdownItems={options}
      withArrow
    >
      {isPersonalHeader ? 'Personal' : 'Organization'}
    </HomepageDropdownBase>
  )
}
